import { render, staticRenderFns } from "./temhead7.vue?vue&type=template&id=dedbc708&scoped=true"
import script from "./temhead7.vue?vue&type=script&lang=js"
export * from "./temhead7.vue?vue&type=script&lang=js"
import style0 from "./temhead7.vue?vue&type=style&index=0&id=dedbc708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedbc708",
  null
  
)

export default component.exports